import { Building2, User } from 'lucide-react';

/**
 * Empresa / Persona natural.
 *
 * Define qué campos pide el formulario de cliente: una empresa necesita nombre
 * de contacto y razón social; una persona natural solo su nombre, que se
 * replica en empresa para que las cotizaciones siempre tengan razón social.
 *
 * Se usa en ClientesList y en el wizard de CotizacionForm.
 */

export const TIPO_EMPRESA = 'empresa';
export const TIPO_PERSONA = 'persona';

const OPCIONES = [
    { value: TIPO_EMPRESA, label: 'Empresa', Icon: Building2 },
    { value: TIPO_PERSONA, label: 'Persona natural', Icon: User }
];

// Razon social a mostrar y guardar. En persona natural es el nombre, pero nunca
// pisamos data.empresa: asi alternar el tipo no borra la empresa ya escrita
export const empresaEfectiva = ({ tipo, nombre, empresa }) => (
    tipo === TIPO_PERSONA ? (nombre || '') : (empresa || '')
);

const ClienteTipoToggle = ({ value, onChange, name = 'cliente-tipo', disabled = false }) => (
    <div className="field">
        <span className="label">Tipo de cliente *</span>
        <div className="tipo-cliente-group" role="radiogroup" aria-label="Tipo de cliente">
            {OPCIONES.map(({ value: opcion, label, Icon }) => (
                <label
                    key={opcion}
                    className={`tipo-cliente-option ${value === opcion ? 'is-active' : ''}`}
                >
                    <input
                        type="radio"
                        name={name}
                        value={opcion}
                        checked={value === opcion}
                        onChange={() => onChange(opcion)}
                        disabled={disabled}
                    />
                    <Icon size={15} aria-hidden="true" />
                    <span>{label}</span>
                </label>
            ))}
        </div>
    </div>
);

export default ClienteTipoToggle;
